import LegacyPublication from "models/interfaces/legacy-publication";
import { Record as ImmutableRecord } from "immutable";
import PublicationRecord, {
    defaultValues as publicationDefaultValues,
} from "./publication-record";
import Publication from "models/interfaces/publication";

const defaultValues: LegacyPublication = {
    ...publicationDefaultValues,
    totalPages: undefined,
    legacyPublicationPages: undefined,
    tableOfContents: [],
};

export default class LegacyPublicationRecord
    extends ImmutableRecord(defaultValues)
    implements LegacyPublication
{
    constructor(params?: LegacyPublication) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        super(params);
    }

    public fromPublicationRecord(
        publication: PublicationRecord
    ): LegacyPublicationRecord {
        const values: Publication = {
            ...publication.toJS(),
            coverImageFile: publication.coverImageFile,
            contentSourceFile: publication.contentSourceFile,
        };

        const data: LegacyPublication = {
            ...values,
            tableOfContents: this.tableOfContents,
            legacyPublicationPages: this.legacyPublicationPages,
            totalPages: this.totalPages,
        };

        return new LegacyPublicationRecord(data);
    }

    public toPublicationRecord(): PublicationRecord {
        const values: Publication = {
            ...this.toJS(),
            coverImageFile: this.coverImageFile,
            contentSourceFile: this.contentSourceFile,
        };

        return new PublicationRecord(values);
    }
}
